import NumberFormat from 'react-number-format';
import {SETUP_VIDEO_QA_INITIAL_VALUES, VideoQAModalService} from "@/imports-files/components/model/setup-video-qa"; 
import { CustomToastrAction } from '../custom-toastr';
import {Kanban} from '@/services/pages/clients/candidates/kanban';

export class VideoQAModalAction
{

constructor(router, setApiError, setFlagForRerender, deleteQuestionList, setDeleteQuestionList, setBtnPopup, formRef, setDisabledAddMoreQuestion)
{
  this.router = router;
  this.setApiError = setApiError
  this.setFlagForRerender = setFlagForRerender;
  this.deleteQuestionList  = deleteQuestionList;
  this.setDeleteQuestionList  = setDeleteQuestionList;
  this.videoQAModalService = new VideoQAModalService();
  this.kanban  = new Kanban();
  this.setBtnPopup = setBtnPopup
  this.customToastrAction    =   new CustomToastrAction();
  this.formRef = formRef
  this.setDisabledAddMoreQuestion = setDisabledAddMoreQuestion
}

async submitForm(data, values, fetchedInitialValues)
{
    let operation_type = this.setOperationType(fetchedInitialValues, values);
    values['job_id'] = data.job_id;
    values['job_stage_id'] = data.id;
    values['job_stage_attributes']['id'] = data.id;
    values['job_stage_attributes']['job_id'] = data.job_id;
    values['job_stage_attributes']['stage_id'] = data.stage_id;
    values['job_stage_attributes']['order'] = data.order;
    values = this.setQuestionsValues(values);

    let result = '';
    if(operation_type == 'create')
    {
      // remove id's from the question attributes for creating
      for(let element of values.questions_attributes)
      {
        delete element.id
      }

      result = await this.videoQAModalService.createQuestions(values);
      this.setApiError(result.response)
    }
    else
    {
      result = await this.videoQAModalService.updateQuestions(values);
      this.setApiError(result.response)
    }
  
    if(result.request.status == 200)
    {
      this.setBtnPopup(false);
       this.setFlagForRerender(Math.random()*10000)
    }
    else
    {
       this.formRef.current.setStatus(result.response.data.error);
    }
    
}

setOperationType(fetchedInitialValues, values)
{
    // if the form value changes 
    // or the questions are added or deleted
  //  if(this.formRef.current.dirty || values.questions_attributes.length > fetchedInitialValues.questions_attributes.length)
  //  {
  //     return 'create';
  //  }
  //  else
  //  {
     return 'update';
  //  }
}


async getVideoModalData(data)
{
    let job_id = data.job_id;
    let job_stage_id = data.id;
    let params = {job_id: job_id, job_stage_id: job_stage_id};
    let result     = await this.videoQAModalService.getJobList(params)
    let email_data = await this.kanban.reviewAutomationEmail( job_id, {key: 'move_candidates', stage_id: job_stage_id, list: true});
    this.setApiError(result.request && email_data.request);
    return {component_data: result.data, email_data: email_data};
}

NumberField({field, className, disabled, format, placeholder, style, formik,isAllowed, onValueChange, defaultValue}) {
 
    return <NumberFormat 
      defaultValue = {defaultValue}
      thousandsGroupStyle="thousand"
      name={field.name}
      format={format}
      displayType="input"
      type="text"
      className={className}
      style={style}
      formik={formik}
      disabled={disabled}
      placeholder={placeholder}
      thousandSeparator={true}
      allowNegative={false}
      isAllowed={isAllowed}
      onValueChange={onValueChange}
    />
  }

  setLanguageList(data)
  {
    let list_data = [];
    for(let key of Object.keys(data))
    {
      list_data.push({value: data[key].title, label: data[key].title})
    }
    return list_data;
  }

  setInitialValues(data)
  {
    let initialData = '';
    if(data.component_data.questions_attributes)
    {
        initialData = data.component_data
    }
    else
    {
        initialData = SETUP_VIDEO_QA_INITIAL_VALUES
        let job_stage_attributes = {
          automation: data.component_data.automation,
          disabled_automation: data.component_data.disabled_automation
        }
        initialData.job_stage_attributes = job_stage_attributes
    }
    return initialData;
  }

  onAddClick(formik)
  {
    
    formik.values.questions_attributes.push({question: '', description: '', attempts: 2, answer_time: 30, _destroy: false})
    this.setFlagForRerender(Math.random()*10000)
    
    if(formik.values.questions_attributes.length == 5)
    {
      this.setDisabledAddMoreQuestion(true);
    }
  }

  onDeleteClick(formik, index)
  {
    this.deleteQuestionList.push(formik.values.questions_attributes[index])
    this.deleteQuestionList[this.deleteQuestionList.length - 1]['_destroy'] = true
    this.setDeleteQuestionList(this.deleteQuestionList);
    this.setDisabledAddMoreQuestion(false);
    formik.values.questions_attributes.splice(index, 1);
    this.setFlagForRerender(Math.random()*10000)
  }

  setQuestionsValues(values)
  {
    values.questions_attributes = Object.assign( [], values.questions_attributes, this.deleteQuestionList)
    return values;
  }

}